import _ from 'lodash';
import { connect } from 'react-redux';
import {
	createForStationInvoice,
	send,
	invalidate,
	get,
	publicGet,
	search,
} from '../../modules/accounting/invoiceCreditMemo';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => {
	const canCreditRebillInvoices = !!_.get(
		state.auth.authUser,
		['permissions', 'canCreditRebillInvoices'],
		false
	);

	return {
		canCreditRebillInvoices,
		invoiceCreditMemoMap: state.maps.invoiceCreditMemo || {},
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			createInvoiceCreditMemo: createForStationInvoice,
			sendInvoiceCreditMemo: send,
			invalidateInvoiceCreditMemo: invalidate,
			getInvoiceCreditMemo: get,
			publicGetInvoiceCreditMemo: publicGet,
			searchInvoiceCreditMemos: search,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
